import { render } from "./AddAttachment.vue?vue&type=template&id=a3e7d06e&scoped=true"
import script from "./AddAttachment.vue?vue&type=script&lang=js"
export * from "./AddAttachment.vue?vue&type=script&lang=js"

import "./AddAttachment.vue?vue&type=style&index=0&id=a3e7d06e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3e7d06e"]])

export default __exports__